const initProductsCompare = () => {
    const wrappers = document.querySelectorAll("[data-products-compare]");

    wrappers.forEach((wrapper) => {
        const scrollContainer = wrapper.querySelector("[data-products-compare-scroll]");
        const arrowButton = wrapper.querySelector("[data-products-compare-arrow]");

        if (!scrollContainer || !arrowButton) {
            return;
        }

        const updateArrowState = () => {
            const maxScrollLeft = scrollContainer.scrollWidth - scrollContainer.clientWidth;

            if (maxScrollLeft <= 0) {
                arrowButton.classList.add("is-hidden");
                return;
            }

            if (scrollContainer.scrollLeft >= maxScrollLeft - 1) {
                arrowButton.classList.add("is-hidden");
            } else {
                arrowButton.classList.remove("is-hidden");
            }
        };

        arrowButton.addEventListener("click", () => {
            const scrollAmount = scrollContainer.clientWidth * 0.8;
            scrollContainer.scrollBy({ left: scrollAmount, behavior: "smooth" });
        });

        scrollContainer.addEventListener("scroll", updateArrowState);
        window.addEventListener("resize", updateArrowState);

        requestAnimationFrame(updateArrowState);
    });
};

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initProductsCompare);
} else {
    initProductsCompare();
}
